import { Box, SxProps, Theme, Typography } from '@mui/material'
import { OptimizerCommand, OptimizerSchedule, OptimizerCommandValue } from '../types/ports'
import { TimeString } from '../types/models'
import { DateTime } from 'luxon'
import { Trans, useTranslation } from 'react-i18next'
import colors from '../utils/colors'
import { useState } from 'react'
import { lang } from '../utils/lang'

function value2str(value: OptimizerCommandValue | true | false, offText: string, onText: string): string {
  switch (value) {
    case false:
    case 0:
      return offText
    case 15:
      return '15%'
    case 30:
      return '30%'
    case 45:
      return '45%'
    case 60:
      return '60%'
    case 70:
      return '70%'
    case 85:
      return '85%'
    case true:
    case 100:
      return onText
    default:
      return '?'
  }
}

function ScheduleLine(props: { time: TimeString, command: OptimizerCommand, display: 'none' | 'block', defaultText?: string }) {
  const { time, command, display, defaultText } = props

  const { t } = useTranslation()
  // A heat pump channel sends REASON_DEFAULT when it releases the machine to its own control.
  const released = !!defaultText && command.reason === 'REASON_DEFAULT'
  const color = released ? 'grey' : colors.reason(command.reason)
  const stamp = DateTime.fromISO(time).toLocal()
  const state = command.reason === 'REASON_END_OF_PREVIOUS_ITEM' || released ? '' : value2str(command.value, t('OFF'), t('ON'))
  return <>
    <Box sx={{ display, color }} component="span">{lang.dayNameShort(stamp.weekday)} {stamp.toFormat('HH:mm')}</Box>
    <Box sx={{ display, color }} component="span">{state}</Box>
    <Box sx={{ display, color }} component="span">{released ? defaultText : t(`Reason-${command.reason}`)}</Box>
  </>
}

export interface ScheduleProps {
  schedule: OptimizerSchedule
  sx?: SxProps<Theme>
  /** Shown instead of the state and reason of REASON_DEFAULT lines (heat pump: released to its own control). */
  defaultText?: string
}

export function Schedule(props: ScheduleProps): React.ReactElement {

  const [all, setAll] = useState(false)

  const { schedule, sx, defaultText } = props
  const MORE_LIMIT = 4

  if (schedule.length === 0) {
    return <Box sx={sx}><Trans>No plan</Trans></Box>
  }

  return (
    <Box sx={{
      display: 'grid',
      gridTemplateColumns: '2fr 1fr 3fr',
      ...sx
    }}>
      {schedule.map((s, idx) => <ScheduleLine key={idx} display={!all && idx >= MORE_LIMIT ? 'none' : 'block' } time={s[0]} command={s[1]} defaultText={defaultText}/>)}
      {!all && schedule.length > MORE_LIMIT && <Typography sx={{ cursor: 'pointer' }} onClick={() => setAll(true)}><Trans>(more)</Trans></Typography>}
    </Box>
  )
}
